import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { Common, ResourceStatus } from 'src/app/common';
import { ResourceService, bucketItem } from 'src/app/services/resource.service';

@Component({
  selector: 'admin-edit-resource',
  templateUrl: './edit-resource.component.html',
  styleUrls: ['./edit-resource.component.scss']
})
export class EditResourceComponent {
  ResourceStatus = ResourceStatus;
  @Input() resource?: any;
  @Output() saved = new EventEmitter<any>();
  editorConfig: AngularEditorConfig = Common.EditotConfig_Operator;
  tags: bucketItem[];
  types = ResourceService.resourceTypes;

  constructor(private resourceService: ResourceService) { }

  async ngOnInit() {
    this.tags = await this.resourceService.getTags(true);
  }

  files: File[] = [];
  onFileChange(files: File[]) {
    if (files?.length > 0)
      this.files.push(...files);
  }

  image: File;
  async save() {
    await this.resourceService.save(this.resource, this.image, ...this.files);
    this.saved.emit(this.resource);
  }
}
